import type { DataTableDensity } from './types';

/**
 * Decision #11's open yes/no: borrow direction A's table density (ruled rows, mono identifiers, 13px body)
 * or keep direction B's roomier rows. This line is the answer for every table; pages never pass `density`.
 * /prototype/tables shows both.
 */
export const DEFAULT_TABLE_DENSITY: DataTableDensity = 'compact';

interface DensityClasses {
  /** On <table>: body size. */
  table: string;
  /** On <th>. */
  head: string;
  /** On <td>. */
  cell: string;
  /** Row rule, on every <td> (border-separate tables draw borders on cells). */
  rule: string;
  /** On a `mono` column's <td>. */
  mono: string;
  /** Header row height in px, for sizing the empty state inside `minHeight`. */
  headPx: number;
}

export const DENSITY: Record<DataTableDensity, DensityClasses> = {
  compact: {
    table: 'text-13',
    head: 'h-9 px-3 first:pl-4 last:pr-4',
    cell: 'px-3 py-2 first:pl-4 last:pr-4',
    rule: 'border-line border-b',
    mono: 'font-mono text-[0.78125rem]',
    headPx: 36,
  },
  comfortable: {
    table: 'text-sm',
    head: 'h-11 px-4 first:pl-5 last:pr-5',
    cell: 'px-4 py-3.5 first:pl-5 last:pr-5',
    rule: 'border-transparent border-b',
    mono: '',
    headPx: 44,
  },
};
